import React from "react";
import { appliedAi } from "../data/content";

export default function AppliedAI() {
  return (
    <section
      id="applied-ai"
      className="section-pad border-t border-rule bg-graphite text-inverse"
    >
      <div className="wrap">
        <div className="grid gap-12 lg:grid-cols-12">
          <header className="reveal lg:col-span-5">
            <p className="label text-inverse-muted">07 / Applied AI</p>
            <h2 className="mt-4 font-display text-[clamp(1.75rem,3vw,2.5rem)] font-semibold leading-[1.1] tracking-[-0.02em] text-inverse">
              {appliedAi.headline}
            </h2>
            <p className="mt-6 text-inverse-muted">{appliedAi.body}</p>
            <p className="mt-6 border-l-2 border-accent pl-4 font-mono text-[0.75rem] uppercase tracking-[0.06em] text-accent">
              {appliedAi.note}
            </p>
          </header>

          <div className="reveal lg:col-span-7">
            <ul className="grid gap-px bg-inverse/10 sm:grid-cols-2">
              {appliedAi.topics.map((topic) => (
                <li
                  key={topic}
                  className="bg-graphite-raised px-5 py-6 text-sm text-inverse"
                >
                  <span
                    aria-hidden="true"
                    className="mb-3 block h-1 w-6 bg-accent"
                  />
                  {topic}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
